export enum ContentScriptMessageType {
  TAB_ACTIVE = 'tabActive',
  SELECT_DOCUMENT = 'selectDocument',
  SELECT_VALIDATION_ISSUE = 'selectValidationIssue',
  DOCUMENT_VALIDATION_ISSUES = 'documentValidationIssues',
  WRITE_DOCUMENT_NOTE = 'writeDocumentNote',
  WRITE_REJECTION_COMMENT = 'writeRejectionComment',
  GET_PARTICIPANTS = 'getParticipants',
  GET_DOCUMENT_STATE = 'getDocumentState',
}

export enum BackgroundScriptMessageType {
  OPEN_SIDE_PANEL = 'openSidePanel',
  NAVIGATE_TO = 'navigateTo',
}

export enum SidePanelMessageType {
  SYNC_USER_SETTINGS = 'syncUserSettings',
  ON_DOCUMENT_INTERSECTION = 'onDocumentIntersection',
  ON_REVIEW_BUTTON_CLICK = 'onReviewButtonClick',
  ON_PARTICIPANTS_FETCHED = 'onParticipantsFetched',
  /** Single document state change - for per-document staleness detection */
  ON_DOCUMENT_STATE_CHANGED = 'onDocumentStateChanged',
}

export enum REVIEW_BUTTON_TYPE {
  APPROVED = 'APPROVED',
  RETURNED = 'RETURNED',
  CONFIRM_RETURNED = 'CONFIRM_RETURNED',
  // UNAPPROVED = 'UNAPPROVED', // TODO: handle unapproved and unreturn button logic in skyslope eventually.
  // UNRETURNED = 'UNRETURNED', // Need to figure out what to revert the IngestionDocument complianceStatus to.
}
